import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import useMode from '../../../../hooks/useMode';
import Button from '../../../../components/Button/Button';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';

export type ModelFilters = {
  modelName?: string;
  visible?: boolean;
};

export const defaultFilters: ModelFilters = {
  modelName: '',
  visible: undefined,
};

type FilterBarModelProps = FilterBarProps<ModelFilters> & {
  onAdd?: () => void;
};

/**
 * @component for jobs page
 */
const FilterBarModel: React.FC<FilterBarModelProps> = (props) => {
  const { filters, setFilters, selectedId } = props;
  const mode = useMode();

  const onChange = (e: any) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder="model name"
          autoFocus={isBrowser && !selectedId}
          width={250}
          value={filters.modelName}
          name="modelName"
          onChange={onChange}
        />
        {props.onAdd && (
          <Button
            onClick={props.onAdd}
            title="Add Model"
            variant="primary"
            icon="plus"
          />
        )}
      </Flex>

      {/* <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex> */}
    </Flex>
  );
};

FilterBarModel.propTypes = {
  filters: PropTypes.any.isRequired,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarModel;
